
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Input, Divider } from 'antd';
import { actions } from '../../redux/action';
import { store } from '../../redux/store';
const { TextArea } = Input;
class ShortTextQuestion extends Component {
    constructor(props) {
        super(props);
        this.onTextChanged = this.onTextChanged.bind(this);
    }

    onTextChanged(e) {
        const { questionId } = this.props,
            valueString = e.target.value;
        store.dispatch(actions.updateAnswer(questionId, 1, valueString));
    }

    render() {
        const { questionText, questionNumber, required } = this.props;
        return (
            <div className="Question-Holder">
                <div><h3>{required === true ? <span style={{ color: 'red' }}>*</span> : ""}{"Question #" + questionNumber + ": " + questionText}</h3></div>
                <div className="TextArea TextArea-Holder" >
                    <TextArea
                        allowClear
                        rows={4}
                        onChange={this.onTextChanged} />
                </div>
                <Divider />
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        surveyResponse: state.surveyResponse,
    };
};
export default connect(mapStateToProps)(ShortTextQuestion);